import { GroupMembersPane } from '@/components/GroupPage/GroupMembersPane';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(GroupMembersPane, {
  requiresEvery: [RouteRestrictions.COMMUNITY_ACCESS],
});
